import * as auth from './auth'
import * as buildings from './buildings'
import * as configurations from './configurations'
import * as consumptions from './consumptions'
import * as evInvoices from './evInvoices'
import * as gasConsumptions from './gasConsumptions'
import * as invoices from './invoices'
import * as paymentMethods from './paymentMethods'
import * as receipts from './receipts'
import * as users from './users'

// APIs ------------

const apiClient = {
  auth,
  buildings,
  configurations,
  consumptions,
  evInvoices,
  gasConsumptions,
  invoices,
  paymentMethods,
  receipts,
  users,
}

export default apiClient
